import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { AlertTriangle, Mail, X, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailVerificationBanner({ email, token, onDismiss }) {
  const [resending, setResending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleResend = async () => {
    setResending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, { email }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Verification email sent! Check your inbox.");
    } catch (error) {
      toast.error("Failed to send verification email");
    } finally {
      setResending(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    if (onDismiss) onDismiss();
  };

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6" data-testid="email-verification-banner">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-5 w-5 text-amber-600" />
        </div>
        <div className="flex-1">
          <h4 className="font-medium text-amber-800">Verify your email address</h4>
          <p className="text-sm text-amber-700 mt-1">
            Please verify your email to receive lead notifications, reminders, and digests. 
            Check your inbox for a verification link.
          </p>
          <div className="mt-3 flex items-center gap-3">
            <Button
              size="sm"
              onClick={handleResend}
              disabled={resending}
              className="bg-amber-600 hover:bg-amber-700 text-white"
            >
              {resending ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <>
                  <Mail className="h-4 w-4 mr-2" />
                  Resend Verification Email
                </>
              )}
            </Button>
            <span className="text-xs text-amber-600">{email}</span>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 text-amber-500 hover:text-amber-700"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
